export interface EchoNxCmsStatusCellProps {
  displayFunction: (currentValue: any, currentEntity: any) => StatusDefinition;
}

export interface StatusDefinition {
  color: string,
  textToShow: string
  iconName?: string,
}
